<template>
    <div>
        <modal ref="modal">
            <div class="d-block text-center" slot="title">Include Contacts on Group</div>
            <div class="animated animated-normal fadeIn">
                <div class="form-group">
                    <label>Group(s)</label>

                    <multiselect
                            v-model="form.groups"
                            placeholder="Search or add a group"
                            track-by="id"
                            label="name"
                            :options="groups"
                            :multiple="true">
                    </multiselect>

                    <p class="invalid-feedback" v-if="!form.groups &amp;&amp; form.errors.has('groups')">
                        {{ form.errors.get('groups') }}
                    </p>
                </div>
            </div>
            <div slot="footer">
                <button-loading class="btn btn-primary btn-block" type="button" :loading="form.submitting"
                                @click="saveContacts">Save
                </button-loading>
            </div>
        </modal>
    </div>
</template>
<script>
export default {
        props: ['contacts'],

        data() {
            return {
                groups   : [],
                form     : new Form({}),
            };
        },

        created() {
            Bus.$on('openAddToGroupModal', (data) => {
                this.$refs.modal.open();
            });

            this.fetchGroups();
        },

        methods: {
            setupForm() {
                this.selectedLocation = null;

                this.form = new Form({
                    groups      : [],
                });
            },

            fetchGroups() {
                return this.$http.get('/groups')
                    .then(({data}) => {
                        this.groups = data.data;
                    });
            },

            saveContacts(){
                this.form.contacts = this.contacts;
                this.form.post(this.$laroute.route('contacts-to-group'),)
                .then(response => {
                        this.$refs.modal.close();
                        const message = 'Contacts added';
                        this.$alert({message, type: 'success', title: 'Success!'});
                        this.form.block ? Bus.$emit('LoadBlockedContactList') : Bus.$emit('LoadContactList');
                    })
                    .catch(({data}) => {
                        swal.fire({
                            title: data.title,
                            text : data.message,
                            type : 'error',
                        })
                    });
            }
        }
}
</script>
